import { Canvas } from '@sloyd/3d';
import { EnvSelector } from '@sloyd/ui';
import { useState } from 'react';
import { Prompt, Wrapper } from './ContentMaterialStudio.style';

export type ContentMaterialStudioProps = {
  callbacks: {
    onAnimate: () => void;
    onPrompt: (prompt: string) => void;
  };
};

export function ContentMaterialStudio(props: ContentMaterialStudioProps) {
  const { callbacks } = props;
  const [nodesCount, setNodesCount] = useState(0);
  const [env, setEnv] = useState('studio');

  return (
    <Wrapper className='ContentMaterialStudio-wrapper' data-testid='ContentMaterialStudio-wrapper'>
      <Canvas
        cameraTarget={[0, 0.7, 0]}
        minDistance={0.4}
        maxDistance={0.4}
        cameraPosition={[1, 2, -2]}
        environment={env}
      >
        {/* <Model glb='/space.glb' onNodesReady={setNodesCount} /> */}
      </Canvas>
      <Prompt>
        <EnvSelector env={env} onSelect={setEnv} />
      </Prompt>
    </Wrapper>
  );
}

export default ContentMaterialStudio;
